import { styled } from '@mui/system';

const PageContent = styled('section')(({ theme }) => ({
  padding: '40px 116px',
  ...theme.wrapper,
  position: 'relative',
  [theme.breakpoints.down('lg')]: {
    padding: 50
  },
  [theme.breakpoints.down('md')]: {
    padding: 30
  },
  [theme.breakpoints.down('sm')]: {
    padding: 20
  }
}));

export default PageContent;
